import { LabelRegular } from 'smoothie';

import { BANKING_GENERAL_DISCLOSURE_TEXT } from './legal';

export const BankingGeneralDisclosure = ({
    color = '$gray900',
}: {
    color?: string;
}) => {
    return (
        <LabelRegular color={color}>
            {BANKING_GENERAL_DISCLOSURE_TEXT}
        </LabelRegular>
    );
};
